import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIv_list } from '../../store';
import { addInverter } from '../../store';
import { removeInverter } from '../../store';
import config from '../../config';
import './IVSetting.css';
import axios from 'axios';

function IVSetting() {
  const dispatch = useDispatch();

  const settingList = useSelector((state) => state.settingList || {});
  const Iv_list = useSelector((state) => state.Iv_list || {});
  const ivData = useSelector((state) => state.ivData || {});

  const [inputcommPort, setcommPort] = useState('RS485-CH1');
  const [inputId, setInputId] = useState('1');
  const [inputName, setInputName] = useState('인버터1');
  const [inputProtocol, setInputProtocol] = useState('REMS-1');
  const [inputIP, setInputIP] = useState('192.168.105.101');
  const [inputPort, setInputPort] = useState('502');
  const [inputCapacity, setInputCapacity] = useState('100.000');
  const [inputPVstringNum, setInputPVstringNum] = useState('30');
  const [inputmpptNum, setInputmpptNum] = useState('15');
  const [inputAddpower, setInputAddpower] = useState('0');
  const [isAutoUpdate, setIsAutoUpdate] = useState(true);

  const defaultChannelNames = 'CH1,CH2,CH3,CH4,CH5,CH6,CH7,CH8,CH9,CH10,CH11,CH12,CH13,CH14,CH15,CH16,CH17,CH18,CH19,CH20,CH21,CH22,CH23,CH24,CH25,CH26,CH27,CH28,CH29,CH30'.split(',');
  const defaultCheckedChannels = '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1'.split(',').map(Number);

  const [inputchName, setInputchName] = useState([...defaultChannelNames]);
  const [inputchUsed, setInputchUsed] = useState([...defaultCheckedChannels]);

  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const {
    iv_protocolList = [],
    commPortList = [],
  } = settingList;

  const addpowerKwhToWh = (kwhString) => {
    const v = parseFloat(kwhString);
    if (!Number.isFinite(v) || v < 0) return 0;
    return Math.round(v * 1000);
  };

  const addpowerWhToKwhString = (whValue) => {
    const v = Number(whValue);
    if (!Number.isFinite(v) || v <= 0) return '0';
    const s = (v / 1000).toFixed(3);
    return s.replace(/\.?0+$/, '');
  };

  const isRems = inputProtocol?.toLowerCase() === 'rems-1' || inputProtocol?.toLowerCase() === 'rems-3';
  const isDik = inputProtocol?.toUpperCase() === 'DIK';
  const isDas_tech = inputProtocol?.toUpperCase() === 'Das_tech';
  const isHex_3 = inputProtocol?.toUpperCase() === 'Hex_3';
  const isTelda = inputProtocol?.toUpperCase() === 'Telda_inv';
  const isDongei = inputProtocol?.toLowerCase() === 'dongei_inv';
  const isSpaceone = inputProtocol?.toLowerCase().includes('spaceone');
  const isWillingsInv = inputProtocol?.toLowerCase() === 'willings_inv_m';

  useEffect(() => {
    if (!isAutoUpdate) return;

    const count = Number(inputPVstringNum);
    if (!isNaN(count) && count >= 0 && count <= 32) {
      const newChecked = Array(32).fill(0).map((_, i) => (i < count ? 1 : 0));
      setInputchUsed(newChecked);
    }
  }, [inputPVstringNum, isAutoUpdate]);

  const handleCapacityChange = (e) => {
    let value = e.target.value;
    if (value.includes('.')) {
      const parts = value.split('.');
      if (parts[1].length > 2) {
        value = `${parts[0]}.${parts[1].slice(0, 2)}`;
      }
    }
    setInputCapacity(value);
  };

  useEffect(() => {
    dispatch(fetchIv_list());
  }, [dispatch]);

  /**
   * ivData가 어떤 형태로 오더라도 최대한 장비별로 송수신 카운트를 뽑아내기 위한 헬퍼
   * 우선순위:
   * 1) seq
   * 2) commPort + address(id)
   * 3) commPort + name
   * 4) 최후 fallback으로 index
   */
  const liveCountMaps = useMemo(() => {
  const bySeq = new Map();
  const byPortAddr = new Map();
  const byPortName = new Map();

  const normalize = (v) => String(v ?? '').trim();
  const normalizeUpper = (v) => normalize(v).toUpperCase();
  const normalizeNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? String(n) : '';
  };

  const safeCount = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const registerOne = (item) => {
    if (!item || typeof item !== 'object') return;

    const seq = normalizeNum(item.seq ?? item.iv_seq);
    const commPort = normalizeUpper(item.commPort ?? item.iv_commPort);
    const address = normalizeNum(item.id ?? item.address ?? item.iv_address);
    const name = normalize(item.name ?? item.iv_name);
    const sendCount = safeCount(item.sendCount);
    const receiveCount = safeCount(item.receiveCount);

    const payload = { sendCount, receiveCount };

    if (seq) bySeq.set(seq, payload);
    if (commPort && address) byPortAddr.set(`${commPort}__${address}`, payload);
    if (commPort && name) byPortName.set(`${commPort}__${name}`, payload);
  };

  if (Array.isArray(ivData)) {
    ivData.forEach((item) => registerOne(item));
    return { bySeq, byPortAddr, byPortName };
  }

  const wrappedArray =
    Array.isArray(ivData.entries) ? ivData.entries :
    Array.isArray(ivData.list) ? ivData.list :
    Array.isArray(ivData.data) ? ivData.data :
    null;

  if (wrappedArray) {
    wrappedArray.forEach((item) => registerOne(item));
    return { bySeq, byPortAddr, byPortName };
  }

  const seqArr = Array.isArray(ivData.seq) ? ivData.seq : Array.isArray(ivData.iv_seq) ? ivData.iv_seq : [];
  const commPortArr = Array.isArray(ivData.iv_commPort) ? ivData.iv_commPort : Array.isArray(ivData.commPort) ? ivData.commPort : [];
  const addressArr = Array.isArray(ivData.iv_address) ? ivData.iv_address : Array.isArray(ivData.address) ? ivData.address : Array.isArray(ivData.id) ? ivData.id : [];
  const nameArr = Array.isArray(ivData.iv_name) ? ivData.iv_name : Array.isArray(ivData.name) ? ivData.name : [];
  const sendArr = Array.isArray(ivData.sendCount) ? ivData.sendCount : [];
  const receiveArr = Array.isArray(ivData.receiveCount) ? ivData.receiveCount : [];

  const maxLen = Math.max(
    seqArr.length,
    commPortArr.length,
    addressArr.length,
    nameArr.length,
    sendArr.length,
    receiveArr.length
  );

  for (let i = 0; i < maxLen; i += 1) {
    registerOne({
      seq: seqArr[i],
      commPort: commPortArr[i],
      address: addressArr[i],
      name: nameArr[i],
      sendCount: sendArr[i],
      receiveCount: receiveArr[i],
    });
  }

  return { bySeq, byPortAddr, byPortName };
}, [ivData]);

const getLiveCountsForRow = (index) => {
  const normalize = (v) => String(v ?? '').trim();
  const normalizeUpper = (v) => normalize(v).toUpperCase();
  const normalizeNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? String(n) : '';
  };

  const rowSeq = normalizeNum(Iv_list.seq?.[index]);
  const rowCommPort = normalizeUpper(Iv_list.iv_commPort?.[index]);
  const rowAddress = normalizeNum(Iv_list.iv_address?.[index]);
  const rowName = normalize(Iv_list.iv_name?.[index]);

  if (rowSeq && liveCountMaps.bySeq.has(rowSeq)) {
    return liveCountMaps.bySeq.get(rowSeq);
  }

  const portAddrKey = `${rowCommPort}__${rowAddress}`;
  if (rowCommPort && rowAddress && liveCountMaps.byPortAddr.has(portAddrKey)) {
    return liveCountMaps.byPortAddr.get(portAddrKey);
  }

  const portNameKey = `${rowCommPort}__${rowName}`;
  if (rowCommPort && rowName && liveCountMaps.byPortName.has(portNameKey)) {
    return liveCountMaps.byPortName.get(portNameKey);
  }

  return {
    sendCount: 0,
    receiveCount: 0,
  };
};

  const ivAddclick = async () => {
    const nextId = (parseInt(inputId, 10) + 1).toString();
    const nextName = `${inputName.split(/[0-9]+$/)[0]}${nextId}`;

    const defaultChannelNamesString = 'CH1,CH2,CH3,CH4,CH5,CH6,CH7,CH8,CH9,CH10,CH11,CH12,CH13,CH14,CH15,CH16,CH17,CH18,CH19,CH20,CH21,CH22,CH23,CH24,CH25,CH26,CH27,CH28,CH29,CH30';
    const defaultChannelUsage = '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1';

    const newInverter = {
      name: inputName,
      protocol: inputProtocol,
      capacity: parseFloat(inputCapacity).toFixed(3),
      commPort: inputcommPort,
      id: inputId,
      ip: inputcommPort === 'ETHERNET' ? inputIP : '192.168.0.101',
      port: inputcommPort === 'ETHERNET' ? inputPort : null,
      PVstringNum: inputPVstringNum,
      mpptNum: inputmpptNum,
      chName: defaultChannelNamesString,
      chUsed: defaultChannelUsage,
      addpower: addpowerKwhToWh(inputAddpower),
    };

    try {
      const response = await axios.post(`${config.backendUrl}/api/inverters`, newInverter);
      if (response.status === 201) {
        dispatch(fetchIv_list());
        dispatch(addInverter(newInverter));

        if (!isEditing) {
          setInputId(nextId);
          setInputName(nextName);
          setInputIP(inputIP);
          setInputPort('502');
          setInputCapacity('100.000');
          setInputPVstringNum('30');
          setInputmpptNum('15');
        }
      } else {
        console.error('Failed to add inverter:', response);
      }
    } catch (error) {
      console.error('An error occurred while adding inverter:', error);
    }

    if (isEditing) {
      handleSaveClick();
    }
  };

  const handleEditClick = (port, index) => {
    if (!Iv_list || !Iv_list.iv_commPort || !Iv_list.iv_commPort[index]) {
      console.error('Invalid Iv_list data at port:', port, 'index:', index);
      return;
    }

    let inverter = {};

    if (Iv_list.iv_commPort[index] === 'ETHERNET') {
      inverter = {
        id: Iv_list.iv_address[index] || '',
        name: Iv_list.iv_name[index] || '',
        protocol: Iv_list.iv_protocol[index] || '',
        ip: Iv_list.iv_ethernetIp && Iv_list.iv_ethernetIp[index] ? Iv_list.iv_ethernetIp[index] : '192.168.105.101',
        port: Iv_list.iv_ethernetPort && Iv_list.iv_ethernetPort[index] ? Iv_list.iv_ethernetPort[index] : '502',
        capacity: Iv_list.iv_capa[index] || '0.000',
        PVstringNum: Iv_list.iv_number_of_PVstrings_per_MPPT[index] || '30',
        mpptNum: Iv_list.iv_number_of_mppt[index] || '15',
      };
    } else {
      inverter = {
        id: Iv_list.iv_address[index] || '',
        name: Iv_list.iv_name[index] || '',
        protocol: Iv_list.iv_protocol[index] || '',
        ip: '',
        port: '',
        capacity: Iv_list.iv_capa[index] || '0.000',
        PVstringNum: Iv_list.iv_number_of_PVstrings_per_MPPT[index] || '30',
        mpptNum: Iv_list.iv_number_of_mppt[index] || '15',
      };
    }

    setEditIndex(index);
    setcommPort(Iv_list.iv_commPort[index]);
    setInputId(inverter.id);
    setInputName(inverter.name);
    setInputProtocol(inverter.protocol);
    setInputIP(inverter.ip || '192.168.105.101');
    setInputPort(inverter.port || '502');
    setInputCapacity(inverter.capacity);
    setInputPVstringNum(inverter.PVstringNum);
    setInputmpptNum(inverter.mpptNum);

    try {
      const ap = Iv_list.addpower?.[index];
      setInputAddpower(addpowerWhToKwhString(ap));
    } catch (e) {
      setInputAddpower('0');
    }

    const rawNames = Iv_list.iv_pv_ch_name?.[index];
    const rawUsed = Iv_list.iv_pv_ch_use?.[index];

    const currentNamesValid = inputchName?.length === 30;
    const currentUsedValid = inputchUsed?.length === 30;

    const channelNamesData = currentNamesValid
      ? inputchName
      : (rawNames?.split(',').length >= 30 ? rawNames.split(',') : [...defaultChannelNames]);

    const checkedChannelsData = currentUsedValid
      ? inputchUsed
      : (rawUsed?.split(',').length >= 30 ? rawUsed.split(',').map(Number) : [...defaultCheckedChannels]);

    setInputchName(channelNamesData);
    setInputchUsed(checkedChannelsData);

    setIsEditing(true);
    setShowModal(true);
  };

  const handleChannelCheck = (index) => {
    const newCheckedChannels = [...inputchUsed];
    newCheckedChannels[index] = newCheckedChannels[index] === 1 ? 0 : 1;

    const checkedCount = newCheckedChannels.filter((v) => v === 1).length;

    setIsAutoUpdate(false);
    setInputchUsed(newCheckedChannels);
    setInputPVstringNum(String(checkedCount));
  };

  const handlePVStringNumChange = (e) => {
    setIsAutoUpdate(true);
    setInputPVstringNum(e.target.value);
  };

  const handleSaveClick = async () => {
    const updatedInverter = {
      id: inputId,
      name: inputName,
      protocol: inputProtocol,
      ip: inputcommPort === 'ETHERNET' ? inputIP : Iv_list.iv_ethernetIp?.[editIndex] || '',
      port: inputcommPort === 'ETHERNET' ? inputPort : Iv_list.iv_ethernetPort?.[editIndex] || '',
      capacity: parseFloat(inputCapacity).toFixed(3),
      commPort: inputcommPort,
      PVstringNum: inputPVstringNum,
      mpptNum: inputmpptNum,
      chName: inputchName.join(','),
      chUsed: inputchUsed.join(','),
      addpower: addpowerKwhToWh(inputAddpower),
    };

    const seq = Iv_list.seq[editIndex];

    try {
      const response = await axios.put(`${config.backendUrl}/api/update_inverter/${seq}`, updatedInverter);
      if (response.status === 200) {
        dispatch(fetchIv_list());
      } else {
        console.error('Failed to update inverter:', response);
      }
    } catch (error) {
      console.error('An error occurred while updating inverter:', error);
    }

    setIsEditing(false);
    setShowModal(false);
  };

  const handleDeleteClick = (port, index) => {
    if (Iv_list.iv_commPort[index] === port) {
      const confirmDelete = window.confirm(`${Iv_list.iv_name[index]}을정말로 삭제하시겠습니까? 삭제후 다시는 데이터를 복원할수 없습니다.`);
      if (confirmDelete) {
        axios
          .delete(`${config.backendUrl}/api/inverters/${Iv_list.seq[index]}`)
          .then(() => {
            dispatch(removeInverter({ port, index }));
            window.alert(`${Iv_list.iv_name[index]} : 삭제 완료`);
          })
          .catch((error) => {
            console.error('삭제 중 오류 발생:', error);
          });
      }
    } else {
      console.error('Invalid index or port:', port, index);
    }
  };

  const handleRowClick = (commPort) => {
    let url = '';

    switch (commPort) {
      case 'RS485-CH1':
        url = `${config.backendUrl}/RS485-CH1`;
        break;
      case 'RS485-CH2':
        url = `${config.backendUrl}/RS485-CH2`;
        break;
      case 'RS485-CH3':
        url = `${config.backendUrl}/RS485-CH3`;
        break;
      case 'ETHERNET':
        url = `${config.backendUrl}/ETHERNET`;
        break;
      default:
        return;
    }

    window.open(url, '_blank');
  };

  return (
    <Container className="mt-5">
      <Row className="align-items-center justify-content-center mb-3">
        <Col md="2">
          <Form.Label className="text-center w-100">통신 포트</Form.Label>
          <Form.Control
            as="select"
            value={inputcommPort}
            onChange={(e) => setcommPort(e.target.value)}
            className="text-center"
          >
            {commPortList.map((port, index) => (
              <option key={index} value={port}>
                {port}
              </option>
            ))}
          </Form.Control>
        </Col>

        {inputcommPort === 'ETHERNET' && (
          <>
            <Col md="2">
              <Form.Label className="text-center w-100">IP 주소</Form.Label>
              <Form.Control
                type="text"
                value={inputIP}
                onChange={(e) => setInputIP(e.target.value)}
                className="text-center"
                placeholder="192.168.0.101"
              />
            </Col>
            <Col md="1">
              <Form.Label className="text-center w-100">포트</Form.Label>
              <Form.Control
                type="text"
                value={inputPort}
                onChange={(e) => setInputPort(e.target.value)}
                className="text-center"
                placeholder="502"
              />
            </Col>
          </>
        )}

        <Col md="1">
          <Form.Label className="text-center w-100">장비 ID</Form.Label>
          <Form.Control
            type="text"
            value={inputId}
            onChange={(e) => setInputId(e.target.value)}
            className="text-center"
          />
        </Col>

        <Col md="2">
          <Form.Label className="text-center w-100">인버터 이름</Form.Label>
          <Form.Control
            type="text"
            value={inputName}
            onChange={(e) => setInputName(e.target.value)}
            className="text-center"
          />
        </Col>

        <Col md="2">
          <Form.Label className="text-center w-100">프로토콜 선택</Form.Label>
          <Form.Control
            as="select"
            value={inputProtocol}
            onChange={(e) => setInputProtocol(e.target.value)}
            className="text-center"
          >
            {iv_protocolList.map((protocol, index) => (
              <option key={index} value={protocol}>
                {protocol}
              </option>
            ))}
          </Form.Control>
        </Col>

        {!isRems && !isDas_tech && !isDik && !isHex_3 && !isTelda && !isDongei && !isSpaceone && !isWillingsInv && (
          <>
            <Col md="2">
              <Form.Label className="text-center w-100">MPPT 개수</Form.Label>
              <Form.Control
                type="text"
                value={inputmpptNum}
                onChange={(e) => setInputmpptNum(e.target.value)}
                className="text-center"
              />
            </Col>
            <Col md="2">
              <Form.Label className="text-center w-100">스트링 개수</Form.Label>
              <Form.Control
                type="text"
                value={inputPVstringNum}
                onChange={handlePVStringNumChange}
                className="text-center"
              />
            </Col>
          </>
        )}

        <Col md="1">
          <Form.Label className="text-center w-100">용량 (kW)</Form.Label>
          <Form.Control
            type="text"
            value={inputCapacity}
            onChange={handleCapacityChange}
            className="text-center"
            placeholder="100.00"
          />
        </Col>

        <Col md="2" className="text-center">
          <Button variant="info" onClick={ivAddclick} className="mt-4 w-100">
            인버터 추가
          </Button>
        </Col>
      </Row>

      {Array.from(new Set(Iv_list.iv_commPort || [])).map((port) => (
        <div key={port}>
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th onClick={() => handleRowClick(port)} style={{ cursor: 'pointer' }}>{port}</th>
                <th>장비 ID</th>
                <th>인버터 이름</th>
                <th>프로토콜</th>
                {port === 'ETHERNET' && (
                  <>
                    <th>IP 주소</th>
                    <th>포트</th>
                  </>
                )}
                <th>MPPT 개수</th>
                <th>스트링 개수</th>
                <th>용량</th>
                <th>송신</th>
                <th>수신</th>
                <th>수정</th>
                <th>삭제</th>
              </tr>
            </thead>

            <tbody>
              {(Iv_list.iv_commPort || []).map((commPort, index) => {
                if (commPort !== port) return null;

                const live = getLiveCountsForRow(index);

                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{Iv_list.iv_commPort[index]}</td>
                    <td>{Iv_list.iv_address[index]}</td>
                    <td>{Iv_list.iv_name[index]}</td>
                    <td>{Iv_list.iv_protocol[index]}</td>

                    {port === 'ETHERNET' && (
                      <>
                        <td>{Iv_list.iv_ethernetIp && Iv_list.iv_ethernetIp[index]}</td>
                        <td>{Iv_list.iv_ethernetPort && Iv_list.iv_ethernetPort[index]}</td>
                      </>
                    )}

                    {(
                      ['rems-1', 'rems-3', 'dik', 'das_tech', 'telda_inv', 'dongei_inv', 'willings_inv_m'].includes(
                        Iv_list.iv_protocol[index]?.toLowerCase()
                      ) || Iv_list.iv_protocol[index]?.toLowerCase().includes('spaceone')
                    ) ? (
                      <>
                        <td>-</td>
                        <td>-</td>
                      </>
                    ) : (
                      <>
                        <td>{Iv_list.iv_number_of_mppt[index]}</td>
                        <td>{Iv_list.iv_number_of_PVstrings_per_MPPT[index]}</td>
                      </>
                    )}

                    <td>{Iv_list.iv_capa[index]}</td>
                    <td>{live.sendCount}</td>
                    <td>{live.receiveCount}</td>

                    <td>
                      <Button
                        variant="warning"
                        style={{ padding: '5px 5px', fontSize: '10px', lineHeight: '0.8' }}
                        onClick={() => handleEditClick(port, index)}
                      >
                        수정
                      </Button>
                    </td>

                    <td>
                      <Button
                        variant="danger"
                        style={{ padding: '5px 5px', fontSize: '10px', lineHeight: '0.8' }}
                        onClick={() => handleDeleteClick(port, index)}
                      >
                        삭제
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      ))}

      <Modal show={showModal} onHide={() => setShowModal(false)} className="custom-modal" size="xl">
        <Modal.Header closeButton>
          <Modal.Title>인버터 수정</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Row>
              <Col style={{ width: '200px' }}>
                <Form.Group>
                  <Form.Label>통신 포트</Form.Label>
                  <Form.Control
                    as="select"
                    value={inputcommPort}
                    onChange={(e) => setcommPort(e.target.value)}
                  >
                    {commPortList.map((port, index) => (
                      <option key={index} value={port}>
                        {port}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                {inputcommPort === 'ETHERNET' && (
                  <>
                    <Form.Group>
                      <Form.Label>IP 주소</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputIP}
                        onChange={(e) => setInputIP(e.target.value)}
                        placeholder="192.168.0.101"
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>포트</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputPort}
                        onChange={(e) => setInputPort(e.target.value)}
                        placeholder="502"
                      />
                    </Form.Group>
                  </>
                )}

                <Form.Group>
                  <Form.Label>장비ID(어드레스)</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputId}
                    onChange={(e) => setInputId(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>인버터 이름</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputName}
                    onChange={(e) => setInputName(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>프로토콜 선택</Form.Label>
                  <Form.Control
                    as="select"
                    value={inputProtocol}
                    onChange={(e) => setInputProtocol(e.target.value)}
                  >
                    {iv_protocolList.map((protocol, index) => (
                      <option key={index} value={protocol}>
                        {protocol}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                {isSpaceone && (
                  <Form.Group>
                    <Form.Label>기존 누적 발전 입력(kWh) - 입력 후 재부팅해야 적용됩니다.</Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.001"
                      value={inputAddpower}
                      onChange={(e) => setInputAddpower(e.target.value)}
                      placeholder="0"
                    />
                  </Form.Group>
                )}

                {!isRems && !isDas_tech && !isDik && !isHex_3 && !isDongei && !isSpaceone && !isWillingsInv && (
                  <>
                    <Form.Group>
                      <Form.Label>MPPT 개수</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputmpptNum}
                        onChange={(e) => setInputmpptNum(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>스트링 개수</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputPVstringNum}
                        onChange={handlePVStringNumChange}
                      />
                    </Form.Group>
                  </>
                )}

                <Form.Group>
                  <Form.Label>용량 (kW)</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputCapacity}
                    onChange={handleCapacityChange}
                    placeholder="100.00"
                  />
                </Form.Group>
              </Col>

              <Col style={{ width: '600px', marginTop: '32px' }}>
                {!isRems && !isDas_tech && !isDik && !isHex_3 && !isDongei && !isSpaceone && !isWillingsInv && (
                  <Row className="flex-wrap">
                    {inputchName.map((name, index) => (
                      <Col key={index} md={6} className="mb-2 d-flex align-items-center">
                        <span style={{ width: '20px' }}>{index + 1}</span>

                        <Form.Control
                          type="text"
                          value={name}
                          onChange={(e) => {
                            const newChannelNames = [...inputchName];
                            newChannelNames[index] = e.target.value;
                            setInputchName(newChannelNames);
                          }}
                          className="mx-1"
                          style={{ fontSize: '12px', padding: '4px' }}
                        />

                        <Form.Check
                          type="checkbox"
                          checked={!!inputchUsed[index]}
                          onChange={() => handleChannelCheck(index)}
                          style={{ transform: 'scale(1.0)' }}
                        />
                      </Col>
                    ))}
                  </Row>
                )}
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            취소
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            저장
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default IVSetting;